module.exports = {
  google_verify: '',
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: '香港料理店サイト', // Navigation and Site Title
  titleAlt: '喜乐', // Title for JSONLD
  description: '香港料理店サイトを作成中',
  keywords: '香港 长洲 喜乐',
  url: 'http://localhost:8001/', // Domain of your site. No trailing slash!
  siteUrl: 'http://localhost:8001/', // url + pathPrefix
  siteLanguage: 'hk', // Language Tag on <html> element
  logo: 'static/logo/circle_xile.png', // Used for SEO
  banner: 'static/logo/xilebanner3.r,',
  // JSONLD / Manifest
  favicon: 'static/logo/xile_favicon.png', // Used for manifest favicon generation
  shortName: '喜樂小店', // shortname for manifest. MUST be shorter than 12 characters
  author: 'humuhimi', // Author for schemaORGJSONLD
  themeColor: '#00b0ff',
  backgroundColor: '#ffc400',
  twitter: '', // Twitter Username
  instagram: '',
  facebook: 'https://www.facebook.com/mcmercy.cc',
  line: '',
};
